mutation DeleteEventEmoteWall($eventId: ID!, $emoteWallId: ID!) {
  result: StreamToolsDeleteEventEmoteWall(eventId: $eventId, emoteWallId: $emoteWallId) {
    id
    deleted
  }
}
